import { Injectable } from '@angular/core';
import { Home } from '../model';
import { BaseService } from '../../shared/baseService';

@Injectable({
    providedIn: 'root'
})

export class HomesService extends BaseService<Home> {
    constructor() {
        super('Home');
    }
}
